import { Box, Container, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { FaTelegram } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { FaSquareXTwitter } from "react-icons/fa6";

export default function Join() {
  const matches = useMediaQuery("(max-width:950px)");

  return (
    <Box my={matches ? 5 : 10}>
      <Container>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            py: 6,
            borderRadius: "40px",
            background: "#55CB01",
            boxShadow:
              "0px 2px 4px 0px #0000004D inset,0px -2px 4px 0px #FFFFFF8C inset",
          }}
        >
          <Box pl={matches ? 3 : 10}>
            <Typography
              sx={{
                textAlign: "left",
                fontFamily: "Lilita One",
                fontSize: { md: "55px", xs: "22px" },
                fontWeight: "400",
                color: "#fff",
              }}
            >
              Join BARFBOY Army!
            </Typography>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            pl={matches ? 3 : 10}
            pt={matches ? 1 : 2}
          >
            <a
              href="https://www.instagram.com/BARFBOYmemecoin/?igsh=OW80c3FyZGY0dXY1&utm_source=qr#"
              target="_blank"
              style={{
                textDecoration: "none",
              }}
              rel="noreferrer"
            >
              <AiFillInstagram style={{ fontSize: "60px", color: "#ffff" }} />
            </a>
            <a
              href="https://t.me/BARFBOYofficial"
              target="_blank"
              style={{
                textDecoration: "none",
                marginLeft: "20px",
                marginRight: "20px",
              }}
              rel="noreferrer"
            >
              <FaTelegram style={{ fontSize: "50px", color: "#ffff" }} />
            </a>

            <a
              href="https://x.com/BARFBOYSOL"
              target="_blank"
              style={{ textDecoration: "none" }}
              rel="noreferrer"
            >
              <FaSquareXTwitter style={{ fontSize: "50px", color: "#ffff" }} />
            </a>
          </Box>
          <Typography
            mt={{ xs: 1, sm: 3 }}
            pl={matches ? 3 : 10}
            pr={1}
            sx={{
              textAlign: "left",
              fontFamily: "Montserrat",
              fontSize: { md: "16px", xs: "12px" },
              fontWeight: "400",
              color: "#fff",
            }}
          >
            Join BARFBOY community on Telegram and
            {!matches && <br />} follow us on X for the latest news and
            insights.
          </Typography>
          <Typography
            mt={{ xs: 1, sm: 2 }}
            pl={matches ? 3 : 10}
            pr={1}
            sx={{
              textAlign: "left",
              fontFamily: "Montserrat",
              fontSize: { md: "16px", xs: "12px" },
              fontWeight: "400",
              color: "#fff",
            }}
          >
            Contact Us: <br />
            Promotions@BARFBOYmemecoin.com
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
